/* INVOICES */
export const GET_LIST_INVOICE_TEMPLATE = "GET_LIST_INVOICE_TEMPLATE";
export const GET_LIST_INVOICE_TEMPLATE_SUCCESS =
  "GET_LIST_INVOICE_TEMPLATE_SUCCESS";
export const GET_LIST_INVOICE_TEMPLATE_FAIL = "GET_LIST_INVOICE_TEMPLATE_FAIL";

export const GET_LIST_ROOT_INVOICE_TEMPLATE = "GET_LIST_ROOT_INVOICE_TEMPLATE";
export const GET_LIST_ROOT_INVOICE_TEMPLATE_SUCCESS =
  "GET_LIST_ROOT_INVOICE_TEMPLATE_SUCCESS";
export const GET_LIST_ROOT_INVOICE_TEMPLATE_FAIL =
  "GET_LIST_ROOT_INVOICE_TEMPLATE_FAIL";

export const GET_DETAIL_INVOICE_TEMPLATE = "GET_DETAIL_INVOICE_TEMPLATE";
export const GET_DETAIL_INVOICE_TEMPLATE_SUCCESS =
  "GET_DETAIL_INVOICE_TEMPLATE_SUCCESS";
export const GET_DETAIL_INVOICE_TEMPLATE_FAIL =
  "GET_DETAIL_INVOICE_TEMPLATE_FAIL";

export const CREATE_INVOICE_TEMPLATE = "CREATE_INVOICE_TEMPLATE";
export const CREATE_INVOICE_TEMPLATE_SUCCESS =
  "CREATE_INVOICE_TEMPLATE_SUCCESS";
export const CREATE_INVOICE_TEMPLATE_FAIL = "CREATE_INVOICE_TEMPLATE_FAIL";
export const RESET_CREATE_INVOICE_TEMPLATE_STATE =
  "RESET_CREATE_INVOICE_TEMPLATE_STATE";

export const UPDATE_INVOICE_TEMPLATE = "UPDATE_INVOICE_TEMPLATE";
export const UPDATE_INVOICE_TEMPLATE_SUCCESS =
  "UPDATE_INVOICE_TEMPLATE_SUCCESS";
export const UPDATE_INVOICE_TEMPLATE_FAIL = "UPDATE_INVOICE_TEMPLATE_FAIL";

export const DELETE_INVOICE_TEMPLATE = "DELETE_INVOICE_TEMPLATE";
export const DELETE_INVOICE_TEMPLATE_SUCCESS =
  "DELETE_INVOICE_TEMPLATE_SUCCESS";
export const DELETE_INVOICE_TEMPLATE_FAIL = "DELETE_INVOICE_TEMPLATE_FAIL";

export const GET_LIST_INVOICE_TYPE = "GET_LIST_INVOICE_TYPE";
export const GET_LIST_INVOICE_TYPE_SUCCESS = "GET_LIST_INVOICE_TYPE_SUCCESS";
export const GET_LIST_INVOICE_TYPE_FAIL = "GET_LIST_INVOICE_TYPE_FAIL";
